<section id="parts-settings-container">
  <form [formGroup]="settingsForm">
    <section id="header">
      <div class="title">
        <div class="main">{{ 'generalSettings.partsGeneralSettings' | translate }}</div>
      </div>

      <div class="actions">
        <button type="button" class="cancel" (click)="cancel()" title="{{ 'generalSettings.cancel' | translate }}">
          {{ 'generalSettings.cancel' | translate }}
        </button>
        <button type="button" class="save-changes" (click)="saveChanges()" title="{{ 'generalSettings.saveChanges' | translate }}">
          <ng-container *ngIf="saveInProgress; else partsSaveLabel">
            <app-loading loadingSymbol="dots" [text]="'saving' | translate" color="white" size=".7" [compact]="true"></app-loading>
          </ng-container>
          <ng-template #partsSaveLabel>{{ 'generalSettings.saveChanges' | translate }}</ng-template>
        </button>
      </div>
    </section>

    <section id="body">
      <section id="left-content">
        <div id="parts-time-management" class="mat-card settings-card" formGroupName="time">
          <div class="card-innner-con">
            <div class="settings-card-title">
              <div class="operational-message-inline">
                <asp-icon name="ic-20-feedback-alert-error.svg" width="1rem" [attr.aria-hidden]="true"></asp-icon>
                {{ 'generalSettings.anyChangesMadeHereWillNotBeUpdatedInTheDMS' | translate }}
                <button type="button" class="dms" (click)="navigateToDIS()" title="Open DIS in new window">DIS</button>
              </div>
              <div class="title-button">
                <button
                  type="button"
                  class="refresh"
                  [disabled]="syncInProgress"
                  [title]="getIntegrationText()"
                  [ngClass]="syncInProgress ? 'disabled' : ''"
                  (click)="syncDealerDisDetails()"
                  [attr.aria-busy]="syncInProgress">
                  <ng-container *ngIf="syncInProgress; else partsSettingsSyncLabel">
                    <app-loading loadingSymbol="dots" [text]="'servicePersonnel.syncInProgress' | translate" color="var(--primary-toyota-color)" size=".6" [compact]="true"></app-loading>
                  </ng-container>
                  <ng-template #partsSettingsSyncLabel>
                    <asp-icon
                      class="icon d-inline-block"
                      name="ic-20-utility-update-small.svg"
                      width="1.2rem"
                      height="1.2rem"
                      color="var(--primary-toyota-color)"
                      [attr.aria-hidden]="true">
                    </asp-icon>
                    <span>{{ getIntegrationText() | translate }}</span>
                  </ng-template>
                </button>
              </div>
            </div>

            <div class="settings-card-body">
              <div class="time-management-overview">
                <div class="operational-container">
                  <div class="operational-title">
                    <span>{{ 'generalSettings.operationalHours' | translate }}</span>
                  </div>
                  <div class="operational-body">
                    <div class="field-container" *ngFor="let obj of hoursOfOperation">
                      <div class="filed-title">
                        <span>{{ getTranslation(obj.day) }}</span>
                      </div>
                      <div class="filed-value">
                        <span class="optional-list-sub" [ngClass]="{ 'no-word-spacing': obj.operation === 'Data not found in DIS' }">
                          {{ obj.operation === 'Closed' ? ('serviceSchedule.closed' | translate) : obj.operation === 'Data not found in DIS' ? ('serviceSchedule.closedConfirm' | translate) : obj.operation }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="time-management-splitter" aria-hidden="true"></div>

                <div class="amenities-container">
                  <div class="amenities-header-row">
                    <div class="operational-title">
                      <span>{{ 'generalSettings.amenities' | translate }}</span>
                    </div>
                    <div class="field-value custom-switch">
                      <app-onofswitch
                        [switchInput]="portalSwitches.enableAmenities"
                        (switchChange)="updateSwitchValues($event, 'enableAmenities')"
                        [attr.aria-label]="'generalSettings.available' | translate">
                      </app-onofswitch>
                      <div class="readonly-layer" *ngIf="!hasAmenities"></div>
                    </div>
                  </div>
                  <div class="amenities-body">
                    <ng-container *ngIf="hasAmenities; else partsNoAmenitiesState">
                      <ul class="amenities-list">
                        <li *ngFor="let value of amenities">{{ value }}</li>
                      </ul>
                    </ng-container>
                    <ng-template #partsNoAmenitiesState>
                      <div class="no-amenities-message">{{ 'generalSettings.noAmenitiesInDIS' | translate }}</div>
                    </ng-template>
                  </div>
                </div>
              </div>

              <div class="field-container time-settings-row">
                <div class="field-input">
                  <div class="field-label">{{ 'generalSettings.timeSlotDuration' | translate }}</div>
                  <mat-form-field appearance="outline">
                    <mat-select formControlName="slotDuration" [attr.aria-label]="'generalSettings.timeSlotDuration' | translate">
                      <mat-option [value]="obj.value" *ngFor="let obj of timeDuration">{{ obj.label }}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="field-input">
                  <div class="field-label">{{ 'generalSettings.onlineAppointmentCut-offTime' | translate }}</div>
                  <mat-form-field appearance="outline">
                    <mat-select formControlName="cutOffTime" [attr.aria-label]="'generalSettings.onlineAppointmentCut-offTime' | translate">
                      <mat-option [value]="obj.value" *ngFor="let obj of curOffTime">{{ obj.label }}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>

              <div class="field-container" style="width: 50%;">
                <div class="field-input">
                  <div class="field-label">{{ 'generalSettings.timezone' | translate }}</div>
                  <mat-form-field appearance="outline">
                    <mat-select formControlName="timeZone" [attr.aria-label]="'generalSettings.timezone' | translate" [attr.aria-required]="true">
                      <mat-option [value]="obj.value" *ngFor="let obj of ((timezones$ | async) | alphabetize:'label')">{{ obj.label }}</mat-option>
                    </mat-select>
                    <mat-error>{{ 'generalSettings.timezoneIsrequired' | translate }}</mat-error>
                  </mat-form-field>
                </div>
              </div>

            </div>
          </div>
        </div>

        <div id="parts-online-portal-settings" class="mat-card settings-card" formGroupName="portal">
          <div class="card-innner-con">
            <div class="settings-card-title">
              <span>{{ 'generalSettings.onlinePortalSettings' | translate }}</span>
              <span class="material-icons" [matTooltip]="tooltip.portal" matTooltipClass="asp-custom-tooltip" role="img" [attr.aria-label]="'generalSettings.manageSettingsOntheCustomerOnlinePortal' | translate">help_outline</span>
            </div>

            <div class="settings-card-body">
              <div class="field-container">
                <div class="settings-spacer"></div>
                <div class="field-title">
                  {{ 'generalSettings.available' | translate }}
                </div>
                <div class="field-value custom-switch">
                  <app-onofswitch
                    [switchInput]="portalSwitches.enableParts"
                    (switchChange)="updateSwitchValues($event, 'enableParts')"
                    [attr.aria-label]="'generalSettings.available' | translate">
                  </app-onofswitch>
                </div>
              </div>

              <div class="field-container pb-3">
                <div class="field-input">
                  <label>{{ 'generalSettings.bannerTitleText' | translate }}</label>
                  <mat-form-field appearance="outline">
                    <input matInput placeholder="{{ 'generalSettings.enterBannerTitleText' | translate }}" formControlName="partsBannerTitleText" type="text">
                  </mat-form-field>
                </div>
                <div class="field-input">
                  <label>{{ 'generalSettings.bannerBodyText' | translate }}</label>
                  <mat-form-field class="no-fixed-height" appearance="outline">
                    <textarea matInput placeholder="{{ 'generalSettings.enterBannerBodyText' | translate }}" formControlName="partsBannerBodyText"></textarea>
                  </mat-form-field>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="right-content">
        <div id="parts-reminder-email-settings" class="mat-card settings-card">
          <div class="card-innner-con">
            <div class="settings-card-title">
              <span>{{ 'generalSettings.customerNotification' | translate }}</span>
              <span class="material-icons" [matTooltip]="tooltip.customerNotification" matTooltipClass="asp-custom-tooltip" role="img" [attr.aria-label]="'generalSettings.enableToAllowUsersToReviceEmailNotifications' | translate">help_outline</span>
            </div>
            <div class="settings-card-body">
              <div class="field-container">
                <div class="filed-title">
                  <span>{{ 'generalSettings.enableCustomerNotification' | translate }}</span>
                </div>
                <div class="settings-spacer"></div>
                <div class="filed-value custom-switch">
                  <app-onofswitch 
                    [switchInput]="customerNotificationEnabled" 
                    (switchChange)="updateSwitchValues($event, 'customerNotificationEnabled')"
                    [attr.aria-label]="'generalSettings.enableCustomerNotification' | translate">
                  </app-onofswitch>
                </div>
              </div>

              <div class="field-container">
                <div class="filed-title">
                  <span>{{ 'generalSettings.reminderNotification' | translate }}</span>
                </div>
                <div class="settings-spacer"></div>
                <div class="filed-value custom-switch" [ngStyle]="{ 'pointer-events': settingsForm.controls['customerNotificationEnabled'].value ? '' : 'none' }">
                  <app-onofswitch 
                    [switchInput]="reminderNotificationEnabled" 
                    (switchChange)="updateSwitchValues($event, 'reminderNotificationEnabled')"
                    [attr.aria-label]="'generalSettings.reminderNotification' | translate"
                    [attr.aria-disabled]="!settingsForm.controls['customerNotificationEnabled'].value">
                  </app-onofswitch>
                </div>
              </div>

              <div class="trans-card">
                <div class="trans-check">{{ 'generalSettings.selectReminderSchedule' | translate }}</div>
                <mat-form-field appearance="outline">
                  <mat-select 
                    multiple 
                    disableRipple 
                    placeholder="{{ 'generalSettings.select' | translate }}" 
                    formControlName="reminderNotificationSchedule"
                    [attr.aria-label]="'generalSettings.selectReminderSchedule' | translate">
                    <mat-option *ngFor="let scheduleVal of scheduleValues" [value]="scheduleVal">{{ scheduleVal }}</mat-option>
                  </mat-select>
                  <mat-error>{{ 'generalSettings.reminderScheduleIsRequired' | translate }}</mat-error>
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>

        <div id="parts-alert-settings" formGroupName="notification" class="mat-card settings-card">
          <div class="card-innner-con">
            <div class="settings-card-title">
              <span>{{ 'generalSettings.alertNotificationSettings' | translate }}</span>
              <span class="material-icons" [matTooltip]="tooltip.notifications" matTooltipClass="asp-custom-tooltip" role="img" [attr.aria-label]="'generalSettings.automatedEmailsWillBeSentForTheTriggerPointsYouSetHere' | translate">help_outline</span>
            </div>

            <div class="settings-card-body" *ngFor="let item of notificationList">
              <div class="field-container">
                <div class="filed-title">
                  <span>{{ item.header | translate }}</span>
                </div>
                <div class="settings-spacer"></div>
                <div class="filed-value custom-switch">
                  <app-onofswitch 
                    [switchInput]="isEnable(item.name)" 
                    (switchChange)="updateSwitchValues($event, item.name)"
                    [attr.aria-label]="(item.header | translate)">
                  </app-onofswitch>
                  <div class="readonly-layer" *ngIf="item.name === 'syncFailure'" [attr.aria-hidden]="true"></div>
                </div>
              </div>

              <div class="d-flex flex-column" [formGroupName]="item.name">
                <mat-accordion>
                  <mat-expansion-panel>
                    <mat-expansion-panel-header>
                      <mat-panel-title>{{ 'generalSettings.emailAddress' | translate }}</mat-panel-title>
                    </mat-expansion-panel-header>

                    <ng-container formArrayName="distributionList">
                      <div class="settings-card-body trans-card d-flex" *ngFor="let email of distributionList(item.name)?.controls; let i = index">
                        <mat-form-field appearance="outline" class="trans-comment">
                          <input 
                            matInput 
                            maxlength="128" 
                            [formControlName]="i"
                            [attr.aria-label]="('generalSettings.emailAddress' | translate) + ' ' + ((i + 1) | number)">
                          <mat-error>{{ 'generalSettings.pleaseEnterValidEmail' | translate }}</mat-error>
                        </mat-form-field>
                        <button 
                          type="button"
                          class="btn asp-btn-secondary asp-btn-height my-auto d-flex align-items-center" 
                          (click)="removeDistributionList(item.name, i)"
                          [title]="'generalSettings.delete' | translate">
                          <asp-icon 
                            name="ic-20-utility-delete-trash.svg" 
                            width="1rem" 
                            color="rgba(14,19,25,0.8)"
                            [attr.aria-hidden]="true">
                          </asp-icon>
                        </button>
                      </div>
                    </ng-container>

                    <button 
                      type="button"
                      class="btn asp-btn-primary asp-btn-width asp-btn-height mt-2 add-btn" 
                      (click)="addDistributionList(item.name)"
                      [title]="'generalSettings.addnew' | translate">
                      {{ 'generalSettings.addnew' | translate }}
                    </button>
                  </mat-expansion-panel>
                </mat-accordion>
              </div>
            </div>
          </div>
        </div>
      </section>
    </section>
  </form>
</section>
